import { dataLayer } from 'analytics/data-layer';
import locator from 'utils/locator';

export const FEATURE_CTA_EVENT_TYPE = {
  IMPRESSION: 'impression',
  CLICK: 'click',
} as const;

export type FeatureCtaEventType =
  (typeof FEATURE_CTA_EVENT_TYPE)[keyof typeof FEATURE_CTA_EVENT_TYPE];

export const FEATURE_CTA_ACTION = {
  CLICK: 'click',
  EXPAND: 'expand',
} as const;

export type FeatureCtaAction = (typeof FEATURE_CTA_ACTION)[keyof typeof FEATURE_CTA_ACTION];

export const FEATURE_CTA_VERTICAL_POSITION = {
  MAIN_TOP: 'main_top',
  MAIN_BOTTOM: 'main_bottom',
  LIST_TOP: 'list_top',
  BELOW_HEADER: 'top_below_header',
} as const;

export type FeatureCtaVerticalPosition =
  (typeof FEATURE_CTA_VERTICAL_POSITION)[keyof typeof FEATURE_CTA_VERTICAL_POSITION];

export function trackFeatureCta({
  eventType,
  feature,
  featureAction,
  featureCtaId,
  linkText,
  linkUrl = '',
  verticalPosition,
}: {
  eventType: FeatureCtaEventType;
  feature: string;
  featureAction?: FeatureCtaAction;
  featureCtaId: string;
  linkText: string;
  linkUrl?: string;
  verticalPosition?: FeatureCtaVerticalPosition;
}) {
  dataLayer.push({
    event: `feature_cta_${eventType}`,
    feature,
    feature_action: featureAction,
    feature_cta_id: featureCtaId,
    link_text: linkText,
    link_url: linkUrl,
    page_location: locator.origin + locator.pathname,
    vertical_pos: verticalPosition,
  });
}
